import cookie from 'react-cookies';
import queryString from 'query-string';

// Constants.
import * as JWTAuthConstants from 'constants/JWTAuthConstants';
import * as AuthConstants from 'constants/AuthConstants';
import * as ProfileConstants from 'constants/ProfileConstants';
import * as ErrorConstants from 'constants/ErrorConstants';

const query = queryString.parse(window.location.search);

const initialState = {
  isLoading: false,
  isLoaded: false,
  token: null,
  message: '',
};

export default function auth(state = initialState, action = {}) {
  switch (action.type) {
    case JWTAuthConstants.JWT_LOGIN_REQUEST:
      return {
        ...state,
        isLoading: true,
        isLoaded: false,
        token: null,
      };
    case JWTAuthConstants.JWT_LOGIN_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        token: action.token,
      };
    case JWTAuthConstants.JWT_LOGIN_FAILURE:
      return {
        ...state,
        isLoading: false,
        isLoaded: false,
        token: null,
      };
    case AuthConstants.LOGOUT_SUCCESS:
    case ProfileConstants.LOAD_PROFILE_FAILURE:
    case ErrorConstants.LOAD_REQUEST_FAILURE:
      return {
        ...state,
        isLoading: false,
        isLoaded: false,
        isAuthenticated: false,
        message: '',
      };
    case '@@router/LOCATION_CHANGE':
      return {
        ...state,
        message: '',
      };
    default:
      return state;
  }
}
